import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProdutoPageFotosComponent } from 'src/app/components/produto/produto-page-fotos/produto-page-fotos.component';
import {LazyLoadImageModule} from 'ng-lazyload-image';
import { GaleriaLightModule } from '../../galeria/galeria-light/galeria-light.module';
import { BtnModule } from '../../btn/btn/btn.module';

@NgModule({
  declarations: [
    ProdutoPageFotosComponent
  ],
  exports: [
    ProdutoPageFotosComponent
  ],
  imports: [
    LazyLoadImageModule,
    GaleriaLightModule,
    BtnModule,
    CommonModule
  ]
})
export class ProdutoPageFotosModule { }
